import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, UserPlus, FileCheck, Inbox, Loader, CheckCircle2, Flag } from "lucide-react";
import api from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((res) => setStats(res.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="mx-auto max-w-7xl px-4 py-16 text-sm text-muted-foreground">Caricamento...</div>;

  const cards = [
    { label: "Iscritti totali", value: stats.iscritti_totali, icon: Users, testid: "admin-stat-iscritti" },
    { label: "Nuovi iscritti", value: stats.nuovi_iscritti, icon: UserPlus, testid: "admin-stat-nuovi" },
    { label: "Richieste agibilità", value: stats.richieste_totali, icon: FileCheck, testid: "admin-stat-richieste" },
    { label: "Richieste ricevute", value: stats.per_stato["RICHIESTA RICEVUTA"] || 0, icon: Inbox, testid: "admin-stat-ricevute" },
    { label: "In lavorazione", value: stats.per_stato["IN LAVORAZIONE"] || 0, icon: Loader, testid: "admin-stat-lavorazione" },
    { label: "Approvate", value: stats.per_stato["APPROVATA"] || 0, icon: CheckCircle2, testid: "admin-stat-approvate" },
    { label: "Completate", value: stats.per_stato["COMPLETATA"] || 0, icon: Flag, testid: "admin-stat-completate" },
  ];

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8" data-testid="admin-dashboard">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-bordeaux">Area Amministrativa</p>
          <h1 className="mt-1 font-heading text-3xl font-bold text-bordeaux-dark">Dashboard ENPALSBOX</h1>
        </div>
        <div className="flex gap-3">
          <Link to="/admin/richieste" data-testid="admin-goto-richieste" className="btn-bordeaux">RICHIESTE DI AGIBILITÀ</Link>
          <Link to="/admin/iscritti" data-testid="admin-goto-iscritti" className="btn-outline-bordeaux">ISCRITTI</Link>
        </div>
      </div>

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <div key={c.label} className="card-elegant !p-5" data-testid={c.testid}>
            <div className="flex items-center justify-between">
              <p className="text-sm text-muted-foreground">{c.label}</p>
              <c.icon className="h-5 w-5 text-bordeaux" />
            </div>
            <p className="mt-2 font-heading text-3xl font-bold text-bordeaux-dark">{c.value.toLocaleString("it-IT")}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
